/* tslint:disable */
/* eslint-disable */
/**
 * Vocalise.API.Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApiWarmupSummaryGet200Response
 */
export interface ApiWarmupSummaryGet200Response {
    /**
     * 
     * @type {boolean}
     * @memberof ApiWarmupSummaryGet200Response
     */
    sunday?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiWarmupSummaryGet200Response
     */
    monday?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiWarmupSummaryGet200Response
     */
    tuesday?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiWarmupSummaryGet200Response
     */
    wednesday?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiWarmupSummaryGet200Response
     */
    thursday?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiWarmupSummaryGet200Response
     */
    friday?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiWarmupSummaryGet200Response
     */
    saturday?: boolean;
}

/**
 * Check if a given object implements the ApiWarmupSummaryGet200Response interface.
 */
export function instanceOfApiWarmupSummaryGet200Response(value: object): value is ApiWarmupSummaryGet200Response {
    return true;
}

export function ApiWarmupSummaryGet200ResponseFromJSON(json: any): ApiWarmupSummaryGet200Response {
    return ApiWarmupSummaryGet200ResponseFromJSONTyped(json, false);
}

export function ApiWarmupSummaryGet200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiWarmupSummaryGet200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'sunday': json['Sunday'] == null ? undefined : json['Sunday'],
        'monday': json['Monday'] == null ? undefined : json['Monday'],
        'tuesday': json['Tuesday'] == null ? undefined : json['Tuesday'],
        'wednesday': json['Wednesday'] == null ? undefined : json['Wednesday'],
        'thursday': json['Thursday'] == null ? undefined : json['Thursday'],
        'friday': json['Friday'] == null ? undefined : json['Friday'],
        'saturday': json['Saturday'] == null ? undefined : json['Saturday'],
    };
}

export function ApiWarmupSummaryGet200ResponseToJSON(json: any): ApiWarmupSummaryGet200Response {
    return ApiWarmupSummaryGet200ResponseToJSONTyped(json, false);
}

export function ApiWarmupSummaryGet200ResponseToJSONTyped(value?: ApiWarmupSummaryGet200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Sunday': value['sunday'],
        'Monday': value['monday'],
        'Tuesday': value['tuesday'],
        'Wednesday': value['wednesday'],
        'Thursday': value['thursday'],
        'Friday': value['friday'],
        'Saturday': value['saturday'],
    };
}

